
export default {
  name: 'TextRepeaterGenerator',
  data () {
    return {
      data: '',
      form: this.$vform({
        text: null,
        repetitions: 12,
        text_between_repetitions: ',',
        newline: 1
      })
    }
  },
  methods: {
    onTextRepeaterGenerator() {
        this.form.post(`/tool/text-repeater-generator`, { progress: false }).then(res => {
          this.data = Object.values(res.data);
        }).catch(e => {
          console.log(e);
        });
    },
    onSample(){
        this.form.text                     = 'Hello';
        this.form.repetitions              = 12;
        this.form.text_between_repetitions = ',';
        this.form.newline                  = 0;
    },
    onReset(){
        this.form.reset();
        this.data = '';
    },
    copyToClipboard() {
      document.getElementById("text").select();
      document.execCommand('copy');
    }
  }
}
